<template>
  <span class="relative">
    <span v-if="!hasBasket" class="mr-3 py-1 px-3">
      <svg
        class="w-4 -my-1 fill-current"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.034 4C5.328 1.815 7.51 0 10 0c2.49 0 4.672 1.815 4.966 4h2.881a2 2 0 011.98 2.283l-1.714 12A2 2 0 0116.133 20H3.867a2 2 0 01-1.98-1.717l-1.714-12A2 2 0 012.153 4h2.88zm7.894 0c-.304-1.062-1.53-2-2.928-2s-2.624.938-2.928 2h5.856zM2.153 6H5v2h2V6h6v2h2V6h2.847l-1.714 12H3.867L2.153 6z"
        />
      </svg>
    </span>
    <button
      v-if="hasBasket"
      @click="toggleMiniBasket"
      class="inline-flex items-center rounded-sm text-top bg-top-text font-bold border-0 py-1 px-3 mr-3 h-8"
      :class="{'attention' : showBasketMessage }"
    >
      <span>
        <svg
          class="w-4 -my-1 text-top fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.034 4C5.328 1.815 7.51 0 10 0c2.49 0 4.672 1.815 4.966 4h2.881a2 2 0 011.98 2.283l-1.714 12A2 2 0 0116.133 20H3.867a2 2 0 01-1.98-1.717l-1.714-12A2 2 0 012.153 4h2.88zm7.894 0c-.304-1.062-1.53-2-2.928-2s-2.624.938-2.928 2h5.856zM2.153 6H5v2h2V6h6v2h2V6h2.847l-1.714 12H3.867L2.153 6z"
          />
        </svg>
      </span>
      <span class="ml-2">{{ basketTotal | toCurrency }}</span>
    </button>

    <div class="absolute text-center" style="bottom:110%;left:0;right:0;" v-if="hasBasket && showPlusMinus">
      <button
        class="inline-block bg-red-500 text-white p-1 mx-2"
        @click="subtractMinute"
      >-m</button>
      <button
        class="inline-block bg-green-500 text-white p-1 mx-2"
        @click="addHour"
      >+h</button>
    </div>
  </span>
</template>

<script>
import store from "./store";
import axios from "axios";
import { bus } from '../index';

export default {
  props: {
    showPlusMinus: Boolean
  },
  computed: {
    basket: function() {
      return this.$store.getters.basket;
    },
    hasBasket: function() {
      return this.$store.getters.hasBasket;
    },
    basketTotal: function() {
      return this.$store.getters.basketTotal;
    },
    showBasketMessage: function() {
      return this.$store.getters.showBasketMessage;
    }
  },
  methods: {
    toggleMiniBasket: function() {
      this.$store.dispatch("toggleMiniBasket");
    },
    subtractMinute: function() {
      axios
        .get("/umbraco/surface/BasketSurface/SubtractMinuteFromReservations")
        .then(response => {
          this.$store.dispatch("updateBasket");
        });
    },
    addHour: function() {
      axios
        .get("/umbraco/surface/BasketSurface/AddHourToReservations")
        .then(response => {
          this.$store.dispatch("updateBasket");
        });
    }
  }
};
</script>
